/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { ModelsPlatformPaymentsOutput } from "../../entities/models/PlatformPaymentsOutput";
import { modelsPlatformPaymentOutputSchema } from "./platformPaymentOutputSchema";
import { z } from "zod/v4";

export const modelsPlatformPaymentsOutputSchema = z.object({
    get "items"(){
                return z.array(modelsPlatformPaymentOutputSchema).optional()
              },
"limit": z.optional(z.int()),
"offset": z.optional(z.int()),
"total": z.optional(z.int())
    }) as unknown as z.ZodType<ModelsPlatformPaymentsOutput>